import { getCurrentImprintAreaKey, getTecSysItemFlag } from '../main/selectors';
import { getFinalBomOptionsSelection, getMatchTrimColor, getSelectedComponentId } from '../bom/selectors';
import { getImprintAreasInit, getImprintColors, getSelectedImprintAreas } from '../imprintarea/selectors';

import { colorSpace } from '../utils/constants';
import { createSelector } from 'reselect';
import { imprintColorFormat } from '../imprintarea/logics';
import { promoStudioUITypeValue } from '../main/constants';

export const getPromoStudioUIType = (state) => {
  return state.specs.promoStudioUIType;
};

export const getIsLiteParentChildItem = (state) => {
  return state.specs.promoStudioUIType === promoStudioUITypeValue.LiteUI && state.specs.isMainItem;
};

export const getChildItemIdFromBomSelectionForLite = createSelector(
  getIsLiteParentChildItem,
  getFinalBomOptionsSelection,
  (isLiteParentChildItem, bomSelection) => {
    if (!isLiteParentChildItem) return '';

    const { generalOptions } = bomSelection;
    return generalOptions.length > 0 ? generalOptions[0].componentId : '';
  }
);

export const getSelectedImprintAreasForLite = createSelector(
  getSelectedImprintAreas,
  (state) => state.imprintLocationDict,
  (selectedImprintAreas, imprintLocations) => {
    let selectedImprintAreasLite = [];
    selectedImprintAreas.forEach((imprintArea) => {
      if (imprintArea.description === 'Standard')
        selectedImprintAreasLite.push(
          Object.assign({}, imprintArea, { description: imprintLocations[imprintArea.key][0].locationDescription })
        );
      else selectedImprintAreasLite.push(imprintArea);
    });
    return selectedImprintAreasLite;
  }
);

export const getSharedArtColors = createSelector(
  (state) => state.sharedArtColorsDict,
  (state, currentImprintAreaKey, currentSelectedSharedArt) => currentSelectedSharedArt,
  (_, currentImprintAreaKey) => currentImprintAreaKey || getCurrentImprintAreaKey,
  getMatchTrimColor,
  getImprintColors,
  (sharedArtColorsDict, currentSelectedSharedArt, currentImprintAreaKey, bomTrimColor, imprintColor) => {
    let clrlst = [];
    if (currentSelectedSharedArt) {
      const currentSharedArtColor =
        (sharedArtColorsDict[currentImprintAreaKey] &&
          sharedArtColorsDict[currentImprintAreaKey][currentSelectedSharedArt.scene7FileName]) ||
        [];
      if (currentSharedArtColor.length === 0 && currentSelectedSharedArt.colorSpace !== colorSpace.MultipleColor) {
        clrlst = imprintColor;
      } else {
        clrlst = imprintColorFormat(currentSharedArtColor, bomTrimColor);
      }
    }

    return clrlst;
  }
);

export const getIsExistInBackups = createSelector(
  (state) => state.backups,
  getChildItemIdFromBomSelectionForLite,
  (backups, childItemId) => {
    const backupKeyList = Object.keys(backups);
    return backupKeyList.some((backupKey) => backupKey === childItemId);
  }
);

export const getBackupByChildItemId = createSelector(
  (state) => state.backups,
  getChildItemIdFromBomSelectionForLite,
  (backups, childItemId) => backups[childItemId]
);
export const getLiteSharedArtsDict = (state) => state.liteSharedArtsDict;

export const getLiteSharedArtColorsDict = (state) => state.liteSharedArtColorsDict;

export const getSharedArtsForComponentId = createSelector(
  getFinalBomOptionsSelection,
  getLiteSharedArtsDict,
  (finalBomOptionsSelection, liteSharedArtsDict) => {
    let sharedArt = {};
    const generalOptions = finalBomOptionsSelection.generalOptions;
    for (let imprintAreaKey in liteSharedArtsDict) {
      for (let option of generalOptions) {
        if (liteSharedArtsDict[imprintAreaKey][option.componentId]) {
          sharedArt[imprintAreaKey] = liteSharedArtsDict[imprintAreaKey][option.componentId];
          break;
        }
      }
      if (!sharedArt[imprintAreaKey]) sharedArt[imprintAreaKey] = liteSharedArtsDict[imprintAreaKey]['Default'];
    }
    return sharedArt;
  }
);

export const getSharedColorsForComponentId = createSelector(
  getFinalBomOptionsSelection,
  getLiteSharedArtColorsDict,
  (finalBomOptionsSelection, liteSharedArtColorsDict) => {
    let sharedArtColor = {};
    const generalOptions = finalBomOptionsSelection.generalOptions;
    for (let imprintAreaKey in liteSharedArtColorsDict) {
      for (let option of generalOptions) {
        if (liteSharedArtColorsDict[imprintAreaKey][option.componentId]) {
          sharedArtColor[imprintAreaKey] = liteSharedArtColorsDict[imprintAreaKey][option.componentId];
          break;
        }
      }
      if (!sharedArtColor[imprintAreaKey])
        sharedArtColor[imprintAreaKey] = liteSharedArtColorsDict[imprintAreaKey]['Default'];
    }
    return sharedArtColor;
  }
);

export const getPrevLiteSharedArtDict = (state) => state.ui.prevLiteSharedArtDict;
export const getPrevLiteSharedArtColorsDict = (state) => state.ui.prevLiteSharedArtColorsDict;

export const getTextColorByComponentId = createSelector(
  (_, imprintAreaKey) => imprintAreaKey,
  (state) => state.liteTextColorsDict,
  getSelectedComponentId,
  (imprintAreaKey, liteTextColorsDict, componentId) => {
    let textColorByComponentId = {};
    if (liteTextColorsDict[imprintAreaKey][componentId]) {
      textColorByComponentId = liteTextColorsDict[imprintAreaKey][componentId];
    } else {
      textColorByComponentId = liteTextColorsDict[imprintAreaKey]['Default'];
    }
    return textColorByComponentId;
  }
);
export const getShowLiteImprintArea = createSelector(
  getImprintAreasInit,
  getTecSysItemFlag,
  (formatsAndGroups, isTecSysItem) => {
    const { groups } = formatsAndGroups;
    let isShow = false;
    if (!isTecSysItem) {
      for (let key in groups) {
        if (
          groups[key].combinations.length > 1 ||
          (groups[key].combinations.length === 1 && groups[key].combinations[0].selected === false)
        ) {
          isShow = true;
        }
      }
    }
    return isShow;
  }
);
